var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"top"},[_c('common-img',{staticClass:"bg",attrs:{"src":("https://cdn.vip-wifi.com/fangchan/img/" + _vm.banner)}}),_c('div',{staticClass:"qr"},[_c('common-img',{attrs:{"src":_vm.qr}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }